<div class="modal-dialog modal-lg" style="margin-top: 0px; margin-bottom: 0px">
  <div class="modal-content">
    <div class="modal-header">
      <button unity-button class="close" classes="icon-only icon-only-large on_dark" type="button" (click)="cancel()">
        <svg class="unity-icon unity-icon-times">
          <use xlink:href="#unity-icon-times"></use>
        </svg>
      </button>
      <h4 class="modal-title">
        {{ title }}
      </h4>
    </div>

    <div class="modal-body">
      <ep-panel panelType="transparent" *ngIf="articles">
        <ep-row>
          <div class="col-12" style="display: inline-block; max-width: 100%; margin-bottom: 10px; font-size: 1.7em">
            {{ message }}
          </div>
        </ep-row>
        <ep-row>
          <div
            class="col-12"
            *ngFor="let article of articles"
            style="display: inline-block; max-width: 100%; margin-bottom: 5px; font-size: 1.6em; margin-left: 2em"
          >
            {{ article.Article_Desc }}
          </div>
        </ep-row>
        <ep-row>
          <div
            class="col-12"
            style="
              display: inline-block;
              max-width: 100%;
              margin-top: 10px;
              margin-bottom: 5px;
              font-size: 1.7em;
              font-weight: 600;
            "
          >
            Would you like to proceed with deleting the location?
          </div>
        </ep-row>
      </ep-panel>
    </div>
    <div class="modal-footer">
      <button unity-button type="button" classes="primary" (click)="confirm()">Confirm</button>
      <button unity-button type="button" classes="ghost" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>
